import { render, staticRenderFns } from "./vcolumnarChartColor.vue?vue&type=template&id=6c0835b6&scoped=true"
import script from "./vcolumnarChartColor.vue?vue&type=script&lang=js"
export * from "./vcolumnarChartColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0835b6",
  null
  
)

export default component.exports